import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import { applyUiLanguage } from "@/lib/uiLang";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminGameEditor from "@/pages/AdminGameEditor";
import MerchantDashboard from "@/pages/MerchantDashboard";
import MerchantGameEditor from "@/pages/MerchantGameEditor";
import PublicGame from "@/pages/PublicGame";
import MerchantPublic from "@/pages/MerchantPublic";
import ClaimPage from "@/pages/ClaimPage";
import ConditionsPage from "@/pages/ConditionsPage";
import OrganizeContest from "@/pages/OrganizeContest";

function RequireRole({ role, children }) {
  const { user, loading } = useAuth();
  // Advertiser space follows the language saved on the account (else browser).
  useEffect(() => {
    if (user && user.role === "merchant" && user.language) applyUiLanguage(user.language);
  }, [user]);
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="h-10 w-10 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    return (
      <Navigate
        to={user.role === "admin" ? "/admin" : "/merchant"}
        replace
      />
    );
  }
  return children;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/play/:slug" element={<PublicGame />} />
            <Route path="/m/:slug" element={<MerchantPublic />} />
            <Route path="/claim/:token" element={<ClaimPage />} />
            <Route path="/conditions" element={<ConditionsPage />} />
            <Route
              path="/organiser-un-concours"
              element={<OrganizeContest />}
            />
            <Route
              path="/admin"
              element={
                <RequireRole role="admin">
                  <AdminDashboard />
                </RequireRole>
              }
            />
            <Route
              path="/admin/games/:id"
              element={
                <RequireRole role="admin">
                  <AdminGameEditor />
                </RequireRole>
              }
            />
            <Route
              path="/merchant"
              element={
                <RequireRole role="merchant">
                  <MerchantDashboard />
                </RequireRole>
              }
            />
            <Route
              path="/merchant/games/:id"
              element={
                <RequireRole role="merchant">
                  <MerchantGameEditor />
                </RequireRole>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
